export function getCountryCode(locale: string): string {
    const countryCode = locale.split('_')[1] || locale.split('-')[1];
    return countryCode.toUpperCase();
}
